import React from "react";
import { EdgeProps, BaseEdge, getBezierPath } from "reactflow";
import "./CustomEdge.css";

export interface CustomEdgeProps extends EdgeProps {}

const CustomEdge = ({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    id,
    ...rest
}: CustomEdgeProps) => {
    const [edgePath] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    return (
        <>
            <BaseEdge
                {...rest}
                id={id}
                style={{ stroke: "#26a69a", strokeWidth: 3 }}
                path={edgePath}
                markerEnd="arrow"
            />
        </>
    );
};

export default CustomEdge;
